import { defineMessages } from 'react-intl';

export default defineMessages({
  joinAnAttachment: {
    id: 'view.SectionTitle.joinAnAttachment',
    defaultMessage: 'Join a picture or a video of your problem',
  },
  fileInput: {
    id: 'atoms.multiFileUpload.button',
    defaultMessage: 'Attach files',
  },
  dragAndDropFiles: {
    id: 'view.import.fileUploader.dragAndDropFiles',
    defaultMessage: 'Drag and drop files here',
  },
});
